/* src/app/layout/header/header.component.scss */
.top-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  border-bottom: 3px solid #e8eceb;
  width: 100%;
  height: 5.4rem;
  padding: 0.875rem 2rem;
  flex-shrink: 0;
}
.top-header-logo {
  display: inline-block;
  width: 260px;
  position: relative;
  left: -13px;
  top: 1px;
}
/*# sourceMappingURL=header.component-RNCR3NJP.css.map */
